export default __webpack_public_path__ + "f2af291fa71518bfe54b7a54f6c30b05.svg";